<template>
  <user-form userType="Administrator" />
</template>
<script>
import UserForm from '../components/UserForm';

export default {
  name: 'NewUser',
  components: { UserForm },
};
</script>
